import {UI} from "../../../../../../stem-core/ui/UIBase.js";
import {StyleSheet} from "../../../../../../stem-core/ui/Style";

import {Messages} from "../../../../../Messages.js";
import {PaymentMethod} from "../../../../../State.js";
import {styleRule} from "../../../../../../stem-core/decorators/Style";
import {registerStyle} from "../../../../../../stem-core/ui/style/Theme";
import {AddCardModal} from "./AddCardModal.jsx";
import {SelectPrimaryCardModal} from "./SelectPrimaryCardModal.jsx";
import {autoredraw} from "../../../../../../stem-core/decorators/AutoRedraw";
import {MessageElement} from "../../../../../widget/ui/MessageElement.jsx";
import {FormatPaymentMethodDescription} from "../../../../../common/PaymentMethodDescription.jsx";
import {LinkButton} from "../../../../../../core/ui/LinkButton.jsx";


class DefaultPaymentMethodElementStyle extends StyleSheet {
    @styleRule
    container = {
        display: "flex",
        justifyContent: "space-between",
    };
}

@registerStyle(DefaultPaymentMethodElementStyle)
@autoredraw(PaymentMethod)
export class DefaultPaymentMethodElement extends UI.Element {
    render() {
        const defaultPaymentMethod = PaymentMethod.getPrimary();

        return [
            <MessageElement 
                testId="walletPrimaryCardDetails"
                message={defaultPaymentMethod ? FormatPaymentMethodDescription(defaultPaymentMethod) : Messages.addCard}
            />,

            <LinkButton
                label={defaultPaymentMethod ? Messages.change : Messages.addCard}
                onClick={() => defaultPaymentMethod ? SelectPrimaryCardModal.show() : AddCardModal.show()}
                testId="walletChangeCardButton"
            />
        ];
    }
}
